import React from 'react'

import { FormControl, FormLabel, MenuItem, Select, SelectProps } from '@material-ui/core'

import { BootstrapInput } from './BootstrapInput'
import { useMatchProductsButtonStyles } from './MatchProductsButton'

import { useDefaultMenuItemStyles } from '../hooks/defaultSelectStylesHook'

import { required } from '../common/objectUtils'
import { fixMsAppScrollProps } from '../common/msAppUtils'
import { ensureNumber, EnumConstraint } from '../common/tsUtils'

import { integrationTypeNames, StoreIntegrationType } from '../types/integrationTypeUtils'

export type MatchStoreProductPropSelectorProps<TStoreProp extends number & EnumConstraint<TStoreProp>> = {
  integrationType: StoreIntegrationType

  storeProp: TStoreProp

  storeProps: ReadonlyArray<readonly [TStoreProp, string]>

  onChange: (value: TStoreProp) => void
}

export const MatchStoreProductPropSelector =
  <TStoreProp extends number & EnumConstraint<TStoreProp>>
  ({integrationType, storeProp, storeProps, onChange}: MatchStoreProductPropSelectorProps<TStoreProp>) => {
    const classes = useMatchProductsButtonStyles()
    const menuItemClasses = useDefaultMenuItemStyles()

    const onChangeInner: SelectProps['onChange'] =
      ({target: {value}}) => {
        const newValueProp = required(
          storeProps.find(
            ([propValue]) => propValue === ensureNumber(value)
          ))

        onChange(newValueProp[0])
      }

    return (
      <FormControl fullWidth>
        <FormLabel component="legend" className={classes.helperText}>
          <span className={classes.dash}>—</span>
          Поле товара в {integrationTypeNames[integrationType]}
        </FormLabel>

        <Select
          labelId="store-label"
          value={storeProp}
          onChange={onChangeInner}
          MenuProps={fixMsAppScrollProps}
          input={<BootstrapInput/>}
        >
          {
            storeProps.map(
              ([propValue, propName]) =>
                <MenuItem
                  className={menuItemClasses.menuItem}
                  key={propValue}
                  value={propValue}
                >
                  {propName}
                </MenuItem>
            )
          }
        </Select>
      </FormControl>
    )
  }